import React from 'react'
import styled from 'styled-components'
import Table from '../../procedures/Q8/Layouts/Table/Table'
import TableHead from '../../procedures/Q8/Layouts/Table/TableHead'
import TableHeadCell from '../../procedures/Q8/Layouts/Table/TableHeadCell'
import TableBody from '../../procedures/Q8/Layouts/Table/TableBody'
import TableRow from '../../procedures/Q8/Layouts/Table/TableRow'
import TableBodyCell from '../../procedures/Q8/Layouts/Table/TableBodyCell'
import ProductImage from '../../queries/TeudotDetails/Components/ProductImage'
import { IQuotationDetails } from '../types/quotation'
import selectOnFocus from '../../../../../modules/autoselect'

type Props = {
  details: IQuotationDetails[]
  onPriceChange: (recId: number, newPrice: number) => void
}

const OVERRIDE_BG = '#fff8e1'

const QuotationDetailsTable: React.FC<Props> = ({ details, onPriceChange }) => {
  const handlePriceInput = (recId: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    if (isNaN(value)) return
    onPriceChange(recId, value)
  }

  return (
    <Table>
      <TableHead>
        <TableHeadCell minWidth="50px">#</TableHeadCell>
        <TableHeadCell minWidth="120px">פריט</TableHeadCell>
        <TableHeadCell minWidth="70px">מחיר מחירון</TableHeadCell>
        <TableHeadCell minWidth="70px"> הצעת מחיר</TableHeadCell>
      </TableHead>
      <TableBody>
        {details.map((item) => (
          <TableRow key={item.recId}>
            <TableBodyCell>
              <ImageWrapper>
                <ProductImage id={item.generalProductId} />
              </ImageWrapper>
            </TableBodyCell>
            <TableBodyCell>
              {`${item.productDesc?.trim()} ${item.varietyDesc?.trim()} ${item.sizeId?.trim()} ${item.packDesc?.trim() ?? ''}`}
            </TableBodyCell>
            <TableBodyCell>
              {item.originalPrice.toFixed(2)}
            </TableBodyCell>
            <TableBodyCell background={item.override ? OVERRIDE_BG : undefined}>
              <PriceInput
                type="number"
                value={Number(item.price.toFixed(2))}
                onChange={(e) => handlePriceInput(item.recId, e)}
                onClick={selectOnFocus}
                onWheel={(e) => e.currentTarget.blur()}
                aria-label={`מחיר ${item.productDesc?.trim()}`}
                inputMode="decimal"
                tabIndex={0}
              />
            </TableBodyCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default QuotationDetailsTable

const ImageWrapper = styled.div`
  width: 3.5em;
  height: 3.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
`

const PriceInput = styled.input`
  width: 100%;
  max-width: 5em;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
  font-size: 1em;
  color: inherit;
  padding: 0.2em;
  -webkit-appearance: none;
  appearance: none;
  -moz-appearance: textfield;

  &:focus {
    background: #f0faf8;
    border-radius: 6px;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
